var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIc1H(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1152",
    "data-name": "Rectangle 1152",
    width: 35.121,
    height: 35.121,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_1_h",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(336.272 222.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279-2",
    "data-name": "Group 279",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22011",
    "data-name": "Path 22011",
    d: "M16.383,32.223A15.84,15.84,0,1,1,32.225,16.381,15.858,15.858,0,0,1,16.383,32.223",
    transform: "translate(1.177 1.179)",
    fill: "#ffcc54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22012",
    "data-name": "Path 22012",
    d: "M2.681,18.522A15.826,15.826,0,0,1,28.517,6.249,15.831,15.831,0,1,0,6.246,28.517a15.757,15.757,0,0,1-3.565-10",
    transform: "translate(0.875 0.875)",
    fill: "#ffe8b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22013",
    "data-name": "Path 22013",
    d: "M1.957,5.807V6.67a11.353,11.353,0,0,0,22.706,0V5.807ZM13.31,16.3A9.643,9.643,0,0,1,3.718,7.529H22.906a9.649,9.649,0,0,1-9.6,8.771",
    transform: "translate(4.251 12.613)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22014",
    "data-name": "Path 22014",
    d: "M17.561,0A17.561,17.561,0,1,0,35.121,17.561,17.581,17.581,0,0,0,17.561,0m0,33.4A15.84,15.84,0,1,1,33.4,17.561,15.86,15.86,0,0,1,17.561,33.4",
    transform: "translate(0 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22015",
    "data-name": "Path 22015",
    d: "M2.961,8.026a.858.858,0,0,0,.86-.86,2.484,2.484,0,0,1,4.968,0,.861.861,0,0,0,1.722,0,4.2,4.2,0,1,0-8.409,0,.858.858,0,0,0,.86.86",
    transform: "translate(4.564 6.429)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22016",
    "data-name": "Path 22016",
    d: "M7.226,8.026a.858.858,0,0,0,.86-.86,2.484,2.484,0,0,1,4.968,0,.861.861,0,0,0,1.722,0,4.2,4.2,0,1,0-8.409,0,.858.858,0,0,0,.86.86",
    transform: "translate(13.828 6.429)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22017",
    "data-name": "Path 22017",
    d: "M12.107,15.121a9.649,9.649,0,0,1-9.6-8.771H21.7a9.649,9.649,0,0,1-9.6,8.771",
    transform: "translate(5.454 13.793)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc1H);
export default __webpack_public_path__ + "static/media/ic_1_h.dd8fb27d44c21889e26181f60d87d811.svg";
export { ForwardRef as ReactComponent };